export { default } from "./AssignedStudent";
